import './scss/main.scss';
import { createApp } from 'vue';
import App from './App.vue';
import { i18n } from './i18n.js';
import Utils from './utils.js';
import { router } from './router.js';
import vSelect from 'vue-select';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import * as Sentry from '@sentry/vue';
import { getUser } from './functions.ts';

const app = createApp( App );

if ( import.meta.env.TWC_SENTRY_DSN && import.meta.env.TWC_SENTRY_DSN.length > 0 ) {
    Sentry.init( {
        app: app,
        dsn: import.meta.env.TWC_SENTRY_DSN,
        beforeSend( event ) {
            if ( !event.user ) {
                event.user = {};
            }

            const user = getUser();

            if ( user ) {
                event.user.username = user.Login;
            }

            return event;
        },
    } );
}

dayjs.extend( utc );
dayjs.extend( timezone );
dayjs.extend( customParseFormat );
dayjs.tz.setDefault( 'Europe/Madrid' );

app.use( router );

app.use( i18n );

app.use( Utils, {
    trans: i18n,
} );

app.component( 'VSelect', vSelect );

app.mount( '#app' );
